/** Action type ids from interaction API `userActions[].actionType.id` */

export const ACTION_FACEBOOK_LIKE = 1
export const ACTION_FACEBOOK_UNLIKE = 18
export const ACTION_FACEBOOK_HIDE = 26
export const ACTION_FACEBOOK_UNHIDE = 27
export const ACTION_INSTAGRAM_HIDE = 28
export const ACTION_INSTAGRAM_UNHIDE = 29

const LIKE_ACTION_IDS = new Set([ACTION_FACEBOOK_LIKE, ACTION_FACEBOOK_UNLIKE])
const HIDE_ACTION_IDS = new Set([
  ACTION_FACEBOOK_HIDE,
  ACTION_FACEBOOK_UNHIDE,
  ACTION_INSTAGRAM_HIDE,
  ACTION_INSTAGRAM_UNHIDE,
])

function parseActionTimestamp(ts) {
  if (!ts) return 0
  const t = new Date(ts).getTime()
  return Number.isNaN(t) ? 0 : t
}

function actionTypeId(userAction) {
  return userAction?.actionType?.id ?? userAction?.actionTypeId ?? null
}

/**
 * Latest like/unlike and hide/unhide per message (by timestamp).
 * @returns {{ reaction: 'like' | null, hidden: boolean }}
 */
export function deriveMessageStateFromUserActions(userActions) {
  if (!Array.isArray(userActions) || userActions.length === 0) {
    return { reaction: null, hidden: false }
  }

  const sorted = [...userActions].sort(
    (a, b) => parseActionTimestamp(a.timestamp) - parseActionTimestamp(b.timestamp),
  )

  let lastLikeActionId = null
  let lastHideActionId = null

  for (const ua of sorted) {
    const id = actionTypeId(ua)
    if (LIKE_ACTION_IDS.has(id)) lastLikeActionId = id
    if (HIDE_ACTION_IDS.has(id)) lastHideActionId = id
  }

  const liked = lastLikeActionId === ACTION_FACEBOOK_LIKE
  const hidden =
    lastHideActionId === ACTION_FACEBOOK_HIDE ||
    lastHideActionId === ACTION_INSTAGRAM_HIDE

  return {
    reaction: liked ? 'like' : null,
    hidden: !!hidden,
  }
}

/** Attach `reaction` and `hidden` from `userActions` onto an API message row. */
export function enrichMessageWithUserActions(message) {
  if (!message || typeof message !== 'object') return message
  const { reaction, hidden } = deriveMessageStateFromUserActions(message.userActions)
  const fromApi =
    message.reaction === 'like' || message.reaction === true || message.liked === true
      ? 'like'
      : null
  return {
    ...message,
    reaction: reaction || fromApi,
    hidden,
  }
}
